
/*** RECORD BASED ACTION ****/
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    Slide,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        RecordModel,
        ActionModel} from '../../models/models';
import { FlowRunModel,
         FlowRunFactory,
         FlowScreenModel,
         FlowScreenFactory } from '../../models/modelsFlow';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName, getRecordUuid } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import {ActionComponent} from "./Action";
import {FlowScreenComponent} from "./../flowScreen/FlowScreen";
import {CustomIconComponent} from "./../icons/CustomIcon";
import { startFlow } from "../../services/flowApi";
import { ActionResponseType,
        performAction,
        performDownloadAction,
        redirectApiLink } from "../../services/actionApi";

export const ActionsComponent: React.FC<{
  availableActions: ActionModel[]
}> = ({
  availableActions
}) => {


  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const [actions, setActions] = useState([]);
  const [selectedAction, setSelectedAction] = useState<ActionModel | null>(null);
  const [flowRun, setFlowRun] = useState<FlowRunModel | null>(null);
  const [flowScreen, setFlowScreen] = useState<FlowScreenModel | null>(null);
  const [activeComponentData, setActiveComponentData] = useState<any>({});

  const [isPerformingAction, setIsPerformingAction] = useState<boolean>(false);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorElement(null);
  };


  useEffect(() => {
    if(errorMessage){
     enqueueSnackbar(errorMessage, {
          variant: "error",
       });
    setErrorMessage(null)
    }

    if(successMessage){
     enqueueSnackbar(successMessage, {
          variant: "success",
       });
    setSuccessMessage(null)
    }
  }, [errorMessage, successMessage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.body.style.cursor = isPerformingAction ? 'wait' : 'default';
    return () => {
      document.body.style.cursor='default';
    }

  }, [isPerformingAction])


  const closeAction = () => {
     setActiveComponentData({});
     setSelectedAction(null);
     setIsPerformingAction(false);
  }


  const onActionPerformSuccess = (thisAction: ActionModel, data: ActionResponseType) => {
     if(thisAction.OnSuccess_sys.type==='snackbar' &&
        data.successMessage){
          setSuccessMessage(data.successMessage)
      }

      if(thisAction.OnSuccess_sys.type==='flow' &&
         data.successMessage){

           setSuccessMessage(data.successMessage)

           if(data.activeComponentData.flow_screen){
             const flowRun = new FlowRunFactory().fromJSON(data.activeComponentData.flow_run)
             const flowScreen = new FlowScreenFactory().fromJSON(data.activeComponentData.flow_screen)
             setFlowRun(flowRun)
             setFlowScreen(flowScreen)
           }
      }

      setActiveComponentData(data.activeComponentData);
      setSelectedAction(thisAction);
      setIsPerformingAction(false);
  }

  const onActionPerformError = (err: Error) => {
     setActiveComponentData({});
     setSelectedAction(null);
     setIsPerformingAction(false);
     setErrorMessage(err.message);
  }

  const onActionRedirectSuccess = (thisAction: ActionModel, data: ActionResponseType) => {
    setIsPerformingAction(false);
    if(thisAction.OnSuccess_sys.type ==='snackbar' &&
       data.successMessage){
      setSuccessMessage(data.successMessage);
    }
  }

  const onActionRedirectError = (err: Error) => {
     setIsPerformingAction(false);
     setErrorMessage(err.message);
  }

  const handleClick = (thisAction: ActionModel) => {

    const thisRecordUuid = getRecordUuid(recordUuid)
    const thisObjectApiName = getObjectName(objectName)


    if(thisAction.OnSuccess_sys.type === 'dialog'){
      setIsPerformingAction(true);
      setErrorMessage(null);
      performAction(thisAction, thisObjectApiName, thisRecordUuid, accessToken)
         .then((data: ActionResponseType) => {
           onActionPerformSuccess(thisAction, data)
         })
         .catch((err) => {
           onActionPerformError(err)
         })
      return
    } else if(thisAction.Type_sys === "api-link") {
      setIsPerformingAction(true);
      setErrorMessage(null);
      setSuccessMessage(null);
      redirectApiLink(thisAction, thisObjectApiName, thisRecordUuid, accessToken)
         .then((data: ActionResponseType) => {
           onActionRedirectSuccess(thisAction, data)
         })
         .catch((err) => {
           onActionRedirectError(err)
         })
      return
    } else if(thisAction.OnSuccess_sys.type === 'snackbar'){
      setIsPerformingAction(true);
      setErrorMessage(null);
      performAction(thisAction, thisObjectApiName, thisRecordUuid, accessToken)
         .then((data: ActionResponseType) => {
           onActionPerformSuccess(thisAction, data)
         })
         .catch((err) => {
           onActionPerformError(err)
         })
      return
    } else if(thisAction.OnSuccess_sys.type === 'download'){
      setIsPerformingAction(true);
      setErrorMessage(null);
      performDownloadAction(thisAction, thisObjectApiName, thisRecordUuid, accessToken)
         .then((filename: string) => {
           setSelectedAction(thisAction);
           setIsPerformingAction(false);
         })
         .catch((err) => {
           onActionPerformError(err)
         })
      return
    }
    else if(thisAction.OnSuccess_sys.type === 'flow'){
      //maybe something else
      setIsPerformingAction(true);
      setErrorMessage(null);

      let thisFlowUuid = 'undefined'
      if(thisAction.ReferencedFlow_sys) thisFlowUuid = thisAction.ReferencedFlow_sys.Uuid_sys

      startFlow(accessToken, thisObjectApiName, thisRecordUuid, thisFlowUuid)
         .then((data) => {
           if(data.flowSuccess){
               setSuccessMessage(data.flowSuccess.message)
               setActiveComponentData({});
               setSelectedAction(null);
               setIsPerformingAction(false)
            }
            if(data.flowRun) {
              setFlowRun(data.flowRun)
            }
            if(data.flowScreen){
              setFlowScreen(data.flowScreen)
            }
            setActiveComponentData(data);
            setSelectedAction(thisAction);
            setIsPerformingAction(false);
       })
       .catch((err) => {
         setErrorMessage(`${err}`)
         setActiveComponentData({});
         setSelectedAction(null);
         setIsPerformingAction(false);
       })
      return

    }
    setErrorMessage(`Action type not implemented yet -- ${thisAction.OnSuccess_sys.type}`);
    return
  }

  //4 actions being displayed, if more actions existing, drop-down menu
  const NUMBER_ACTION_THRESHOLD = 4

  //navigation bar element (i.e., objects)
  const actionMenuElement = (thisAction: ActionModel) => {
    let buttonSubClass = {my: 2,
                          color: "white",
                          display: "block",
                          backgroundColor: "inherit",
                          borderBottom: "none",
                          borderRadius: 0};
    return (
      <Box key={thisAction.Uuid_sys}>
        <Button
          variant="contained"
          sx={buttonSubClass}
          color="primary"
          fullWidth
          disabled={false}
          onClick={() => handleClick(thisAction)}
        >
          <Typography
            color="textPrimary"
            style={{
              marginTop: 2,
              marginBottom: 2 }}
          >
            {thisAction.Label_sys}
          </Typography>
          {thisAction.ReferencedIcon_sys &&
            <CustomIconComponent
              icon={{...thisAction.ReferencedIcon_sys,
                     Colour_sys: 'text.secondary'}}
              sx={{
                fontSize: 20,
                fontWeight: 500,
                transform: "translateY(-0.075em)"
              }}
            />
          }
        </Button>
      </Box>
    )
  }


  return (
    <>
    {selectedAction &&
     selectedAction.OnSuccess_sys.type === 'dialog' &&
     <ActionComponent
        selectedAction={selectedAction}
        closeAction={closeAction}
        data={activeComponentData}
      />}


    {flowRun &&
     flowScreen &&
     <FlowScreenComponent
        flowRun={flowRun}
        flowScreen={flowScreen}
      />}


    {/*All Actions as buttons*/}
    <Box sx={{flexGrow: 1,
              display: { xs: 'none', md: availableActions.length > NUMBER_ACTION_THRESHOLD ? 'none' : 'flex'},
              gap: 1,
              flexWrap: "wrap"}}>
       {availableActions.map((thisAction: ActionModel) => {
         return(
            <Button
               key={thisAction.Uuid_sys}
               color="primary"
               variant="contained"
               disabled={false}
               onClick={() => handleClick(thisAction)}
            >
              {thisAction.Label_sys}
              {thisAction.ReferencedIcon_sys &&
                <CustomIconComponent
                  icon={thisAction.ReferencedIcon_sys}
                  sx={{
                    ml: 2,
                    fontSize: 20,
                    fontWeight: 500,
                    transform: "translateY(-0.075em)"
                  }}
                />
              }
            </Button>
         )
       })
     }
    </Box>



  {/*All Actions as drop-down menu*/}
  <Box
    sx={{
      justifyContent: "flex-end",
      display: { xs: 'flex', md: availableActions.length > NUMBER_ACTION_THRESHOLD ? 'flex' : 'none'},
      alignItems: "center"
    }}
  >
    <Typography variant="button">
       Actions
    </Typography>
    <IconButton
      size="large"
      onClick={handleOpenMenu}
      color="inherit"
    >
      <ArrowDropDownIcon />
    </IconButton>

    <Menu
      id="menu-actions"
      anchorEl={anchorElement}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      open={Boolean(anchorElement)}
      onClose={handleCloseMenu}
      sx={{ display: { xs: 'block', md: availableActions.length > NUMBER_ACTION_THRESHOLD ? 'block' : 'none' } }}
    >
       {availableActions.map((thisAction: ActionModel) => {
         return actionMenuElement(thisAction)
       })
     }
    </Menu>
  </Box>


    </>
  );

};
